export default __webpack_public_path__ + "965959d66a5ed4d723c85f3336afe774.gif";